import './index.scss';

import React from 'react';
import PropTypes from 'prop-types';

import { getRightArrowImage } from '../../utils/imageChanges';

const SectionTitle = props => {
  const { title, onClick, showSeeAll, theme, seeAllData, index, customClass } = props;
  return (
    <div className={`section-title ${theme} ${customClass}`}>
      <h2 className="section-title__title">{title}</h2>
      {showSeeAll ? (
        <div
          className="section-title__see-all u_cursor_pointer"
          role="presentation"
          onClick={() => onClick(seeAllData,index)}
        >
          See All
          <img
            src={getRightArrowImage(theme)}
            alt="RightArrow"
            className="section-title__icon"
          />
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default SectionTitle;

SectionTitle.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
  theme: PropTypes.string,
};

SectionTitle.defaultProps = {
  title: '',
  onClick: () => {},
  theme: ''
};
